(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
        document.addEventListener("DOMContentLoaded", function() {
            const elem = getpagi.getAttribute('data-pagination');
            var endlessScroll = new Ajaxinate({
                container: '.AjaxinateLoop',
                pagination: '.AjaxinatePagination',
                loadingText: '<span class="loader-line"></span>',
                method: elem == 'scroll' ? 'scroll' : 'click'
            });
        });
    }
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class productPairsRight extends HTMLElement {
    connectedCallback() {
        fetch(this.dataset.url).
        then((response) => {
            if (!response.ok) {
                throw new Error("HTTP error! Status: ".concat(response.status));
            }
            return response.text();
        }).
        then((response) => {
            var frag = document.createDocumentFragment(),
            fetchedContent = document.createElement('div');
            frag.appendChild(fetchedContent);
            fetchedContent.innerHTML = response;

            var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
            if (replacementContent) {
                this.innerHTML = replacementContent.innerHTML;
            }
        });
    }
}

customElements.define('product-pairsright', productPairsRight);

class BuyNow extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', this.handleClick.bind(this));
    }

    connectedCallback() {
        this.checkAgreement();
    }

    handleClick(event) {
        const agreeCheckbox = this.querySelector('.checkbox__input');
        const checkoutButton = this.querySelector('.product-form__buynow');
        
        if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
            if (agreeCheckbox.checked) {
                checkoutButton.classList.remove('disabled');
            } else {
                checkoutButton.classList.add('disabled');
            }
        }
    }
    checkAgreement() {
        const agreeCheckbox = this.querySelector('.checkbox__input');
        return agreeCheckbox.checked;
    }
}

customElements.define('buy-now', BuyNow);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
    class ParallaxImage extends HTMLElement {
        constructor() {
            super();
          
        }
        connectedCallback() {
            const sectionId = this.getAttribute('section-id');
            const image = this.querySelector('img');
            const aosAnimation = this.getAttribute('data-aos');

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        window.addEventListener('scroll', this.parallaxEffect);
                    } else {
                        window.removeEventListener('scroll', this.parallaxEffect);
                    }
                });
            });

            const section = document.getElementById(sectionId);
            observer.observe(section);

            const imageContainer = this;
            imageContainer.style.transform = 'translateY(0)';

            this.parallaxEffect = () => {
                const scrollPosition = window.pageYOffset;
                const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
                const parallaxValue = (scrollPosition / maxScroll) * 50;
                image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
            };

        }
    }

    customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"] && !Shopify.designMode) return;
  try {
    
    class productPairs extends HTMLElement {
        connectedCallback() {
            fetch(this.dataset.url).
            then((response) => {
                if (!response.ok) {
                  throw new Error("HTTP error! Status: ".concat(response.status));
                }
                return response.text();
            }).
            then((response) => {
                var frag = document.createDocumentFragment(),
                    fetchedContent = document.createElement('div');
                frag.appendChild(fetchedContent);
                fetchedContent.innerHTML = response;

                var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
                if (replacementContent) {
                    this.innerHTML = replacementContent.innerHTML;
                }
            });
        }
    }

    customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();
})();
